import type { Link } from '@webapp/common/entities/link';

export interface LinksState {
    fetch: boolean;
    items: Array<Link>;
}

export const initialState: LinksState = {
    fetch: false,
    items: [],
};
